/*
 * @Author: cc
 * @Date: 2020-04-05 16:34:54
 * @LastEditTime: 2020-05-16 22:08:16
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\tenantManageMent\infoSourceSetting\infoSourceSetting.js
 * @Description: 
 */ 
/**
 * 描述：租户管理--信息源订阅设置
 * 日期：2017-10-13
 * 作者：liu_jinming
 */
'use strict';
angular.module('infoSourceSettingModule', 
    ['hotWarningTplModule',
        'regionRealtedOfficialsModule',
        'weiboDiscloseModule'])
    .controller('infoSourceSettingCtrl', ['$scope', '$state', '$stateParams', function($scope, $state, $stateParams) {
        initStatus();

        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.status = {
                selectedTab: $stateParams.tab,      
                tab: ['hotWarning', 'regionRealtedOfficials', 'weiboDisclose']               
            };          
        }    

        /** [switchNav description: 切换导航栏] */
        $scope.switchNav = function(item) {           
            $scope.status.selectedTab = item;     
            var routerState = 'manageconfig.tenantmanagement.infoSourceSetting.' + $scope.status.tab[item - 1];     
            $state.go(routerState, {tab: item}); 
        };        
    }]);
